import { Container } from './styles';

interface ContainerFormProps {
  children: React.ReactNode;
}

export const ContainerForm: React.FC<ContainerFormProps> = ({ children }) => {
  return <Container>{children}</Container>;
};
